import {
  legacy_createStore as createStore,
  applyMiddleware,
  compose,
} from "redux";
import createSagaMiddleware from "redux-saga";
import rootReducer from "./reducer";
import rootSaga from "./sagas";

// Add type definitions for Redux DevTools and Hot Module Replacement
declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }

  interface NodeModule {
    hot?: {
      accept(path: string, callback: () => void): void;
    };
  }
}

const configureStore = () => {
  const sagaMiddleware = createSagaMiddleware();

  // Setup Redux DevTools Extension with type safety
  const composeEnhancers =
    (window && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

  const store = createStore(
    rootReducer,
    undefined,
    composeEnhancers(applyMiddleware(sagaMiddleware))
  );

  sagaMiddleware.run(rootSaga);

  // Enable Webpack hot module replacement for reducers
  if (process.env.NODE_ENV !== "production" && module.hot) {
    module.hot.accept("./reducer", () => {
      const nextRootReducer = require("./reducer").default;
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
};

export default configureStore;
